import { useCallback } from "react";
import moment from "moment-timezone";
import useAuth from "./useAuth";
import { useGetFirmDetailPerformanceReportMutation } from "../store/storageRoles/firmLogApi";
import { useGetDeviceDetailPerformanceReportMutation } from "../store/storageRoles/devicesSharedApi";
import { useGetDealerRolesFirmDetailPerformanceReportMutation } from "../store/dealerRoles/firmApi";
import { useGetDealerRolesDeviceDetailPerformanceReportMutation } from "../store/dealerRoles/devicesApi";

/**
 * Firma / cihaz detayı Raporlar sekmesinin "Tüketim" raporu (#343).
 * Rol ve konuya göre doğru ucu seçer (merkez / bayi × firma / cihaz).
 * Sözleşme: BayinerIOT-Workspace-/docs/api-contracts/detail-consumption-report.md
 *
 * @param {"firm"|"device"} kind
 * @returns {{ run: Function, report: Object|null, isLoading: boolean, error: any, reset: Function }}
 */
export default function useDetailPerformanceReport(kind) {
  const { auth } = useAuth();
  const isDealer = auth?.role === "dealer";

  const storageFirm = useGetFirmDetailPerformanceReportMutation();
  const storageDevice = useGetDeviceDetailPerformanceReportMutation();
  const dealerFirm = useGetDealerRolesFirmDetailPerformanceReportMutation();
  const dealerDevice = useGetDealerRolesDeviceDetailPerformanceReportMutation();

  const [trigger, state] =
    kind === "device" ? (isDealer ? dealerDevice : storageDevice) : isDealer ? dealerFirm : storageFirm;

  const run = useCallback(
    ({ id, startDate, endDate, productName }) =>
      trigger({
        token: auth?.accessToken,
        id,
        // Seçilen takvim günü (yerel) — sunucu İstanbul gününe genişletir
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: moment(endDate).format("YYYY-MM-DD"),
        productName,
      }),
    [trigger, auth?.accessToken]
  );

  return {
    run,
    report: state.data?.data || null,
    isLoading: state.isLoading,
    error: state.error,
    reset: state.reset,
  };
}
